"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarsHeavyIndustry = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var SelectAmount_1 = require("../../../inputs/SelectAmount");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var OrOptions_1 = require("../../../inputs/OrOptions");
var SelectOption_1 = require("../../../inputs/SelectOption");
var MarsHeavyIndustry = (function (_super) {
    __extends(MarsHeavyIndustry, _super);
    function MarsHeavyIndustry() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MARS_HEAVY_INDUSTRY,
            cost: 8,
            tags: [Tags_1.Tags.BUILDING],
            metadata: {
                cardNumber: 'L302',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action(undefined, function (eb) {
                        eb.text('x').steel(1).startAction.text('x').energy(1);
                    }).br;
                    b.or().br;
                    b.action(undefined, function (eb) {
                        eb.text('x').steel(1).startAction.text('2x').heat(1);
                    }).br;
                }),
                description: 'Spend X (up to 5) steel to get X energy OR 2X heat.',
                victoryPoints: 1,
            },
        }) || this;
    }
    MarsHeavyIndustry.prototype.play = function () {
        return undefined;
    };
    MarsHeavyIndustry.prototype.canAct = function (player) {
        return player.steel > 0;
    };
    MarsHeavyIndustry.prototype.getVictoryPoints = function () {
        return 1;
    };
    MarsHeavyIndustry.prototype.action = function (player) {
        var _this = this;
        var availableSteel = Math.min(5, player.steel);
        if (availableSteel >= 1) {
            return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Spend X (up to 5) steel to gain X energy', 'Get energy', function () {
                return _this.getEnergyOption(player, availableSteel);
            }), new SelectOption_1.SelectOption('Spend X (up to 5) steel to gain 2X heat', 'Get heat', function () {
                return _this.getHeatOption(player, availableSteel);
            }));
        }
        return undefined;
    };
    MarsHeavyIndustry.prototype.getEnergyOption = function (player, availableSteel) {
        return new SelectAmount_1.SelectAmount('Select amount of steel to spend', 'Gain energy', function (amount) {
            player.addResource(Resources_1.Resources.ENERGY, amount);
            player.deductResource(Resources_1.Resources.STEEL, (amount));
            player.game.log('${0} gained ${1} energy', function (b) { return b.player(player).number(amount); });
            return undefined;
        }, 1, availableSteel);
    };
    MarsHeavyIndustry.prototype.getHeatOption = function (player, availableSteel) {
        return new SelectAmount_1.SelectAmount('Select amount of steel to spend', 'Gain heat', function (amount) {
            player.addResource(Resources_1.Resources.HEAT, (amount * 2));
            player.deductResource(Resources_1.Resources.STEEL, (amount));
            player.game.log('${0} gained ${1} heat', function (b) { return b.player(player).number(2 * amount); });
            return undefined;
        }, 1, availableSteel);
    };
    return MarsHeavyIndustry;
}(Card_1.Card));
exports.MarsHeavyIndustry = MarsHeavyIndustry;
//# sourceMappingURL=MarsHeavyIndustry.js.map